// src/types/properties/MediaUpload.ts
var UPLOADABLE_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
var MEDIA_UPLOAD_MIN_BYTES = 1024;
var MEDIA_UPLOAD_MAX_BYTES = 52428800;
var MIN_PROPERTY_PHOTOS = 5;
var MIN_ROOM_TYPE_PHOTOS = 1;

export {
  UPLOADABLE_IMAGE_TYPES,
  MEDIA_UPLOAD_MIN_BYTES,
  MEDIA_UPLOAD_MAX_BYTES,
  MIN_PROPERTY_PHOTOS,
  MIN_ROOM_TYPE_PHOTOS
};
